/* ============================================================
   search.js — header search overlay's live suggestions.

   The static build's version of this file searched a hand-rolled
   catalog.json and rendered results into the dedicated /search page's
   own grid. Both of those things changed on Shopify: the /search page
   itself is now fully server-rendered by Liquid (real search.results —
   works before JS even loads), and this file's only remaining job is
   the header overlay's live-as-you-type suggestions, backed by
   Shopify's real predictive search endpoint (/search/suggest.json)
   instead of a local catalog.
   ============================================================ */
(function () {
  "use strict";

  var input = document.querySelector("[data-search-input]");
  var resultsEl = document.querySelector("[data-search-results]");
  var resLabel = document.querySelector("[data-search-reslabel]");
  var popularEl = document.querySelector("[data-search-popular]");
  if (!input || !resultsEl) return;

  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.GHONCHE_MONEY_FORMAT);
    }
    return "Rs. " + Math.round((Number(cents) || 0) / 100).toLocaleString("en-PK");
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function resultRowHTML(p) {
    return (
      '<a class="search__result" href="' + esc(p.url) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '&width=100" alt="" width="50" height="66" loading="lazy">' : "") +
        '<span class="search__result-info">' +
          '<span class="search__result-title">' + esc(p.title) + "</span>" +
          '<span class="search__result-price">' + fmt(p.price) + "</span>" +
        "</span>" +
      "</a>"
    );
  }

  var debounceTimer = null;
  function runSuggest(q) {
    if (!q) {
      resultsEl.innerHTML = "";
      if (resLabel) resLabel.hidden = true;
      if (popularEl) popularEl.hidden = false;
      return;
    }
    if (popularEl) popularEl.hidden = true;
    fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (resLabel) resLabel.hidden = products.length === 0;
        resultsEl.innerHTML = products.map(resultRowHTML).join("");
      })
      .catch(function () {});
  }

  input.addEventListener("input", function () {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    debounceTimer = setTimeout(function () { runSuggest(q); }, 200);
  });
})();
